import { apiCall } from "./auth";
import { API_URL } from "./config";


export const StagingStAdd = (data) => apiCall(`${API_URL}StagingSt/StagingStAdd`, "POST",data)
export const StagingStUpdate = (data) => apiCall(`${API_URL}StagingSt/StagingStUpdate`, "POST", data)
export const StagingStGet = (data) => apiCall(`${API_URL}StagingSt/StagingStGet`, "POST", data)
export const StagingStGetById = (data) => apiCall(`${API_URL}StagingSt/StagingStGetById`, "POST", data)